import axiosInstance from './axiosInstance';
import { formatDate } from '../utils/helpers';

const getDeposits = (filters = {}) => {
  const { perPage, page, email, currency, status, from, to } = filters;

  return axiosInstance.get('/internal/admin/deposits', {
    params: {
      per_page: perPage,
      page,
      email,
      currency_id: currency,
      status,
      payed_from: from ? formatDate(from, 'MM/DD/YYYY hh:mm A') : null,
      payed_to: to ? formatDate(to, 'MM//DD/YYYY hh:mm A') : null,
    },
  });
};

export default getDeposits;
